/* App settings */

import env from "../env.json";
// import env from "../envKsa.json";
import CONSTANTS from "./constants.service";

// import Storage from "./storage.service";
var Settings = env;

// console.log(
//     "%c%s",
//     "color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
//     "Build No: " + Settings['buildNumber']
// );
// if (Settings['deployedAt']) {
//     console.log(
//         "%c%s",
//         "color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
//         "Deployed on: " + Settings['deployedAt']
//     );
// }

Settings.order = ["VOICE-LCL", "DATA", "VOICE-INT"];

Settings.cc_mask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
Settings.formats = {
  // email:/^\w(.\w*)+@[a-zA-Z_]+?\.[a-zA-Z]{2,5}$/,
  email:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  cardnumber: /^[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}$/,
  cardcvv: /^([0-9]{3})$/,
  cardcvvinitial: /^([0-9]{1,3})$/,
  expiry: /^[0-9]{1,2}\/[0-9]{2}$/,
  phonenumber: /^[0-9]{6,14}$/,
  phonenumberContact: /^[0-9]{6,9}$/,
  phonefragment: /^[0-9]{0,8}$/,
  phonefragmentKw: /^[0-9]{0,7}$/,
  phonefragmentmax: /^[0-9]{0,10}$/,
  phonefragmentmaxKw: /^[0-9]{0,6}$/,
  text_only: /^([^0-9]*)$/,
  card_number_mask: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  // minLength: /(.{8,})/,
  // oneDigit: /(?=.*?[0-9])/,
  // oneUpperCaseCharacter: /(?=.*[A-Z])/,
  password: /^(?=.*\d)(?=.*[A-Z]).{8,}$/,
  notEmpty: /\S+/,
  otpCode: /^([0-9]{6})$/,
  otpCodeWithoutLength: /^[0-9]*$/,
  country: /^([A-Z]{2})$/,
  min_chars_8: /^.{8,}$/,
  number_required: /.*[0-9].*/,
  uppercase: /(.*[A-Z].*)/,
  digits_only: /^\d+$/,
  ksaLandline: /^(?:\+?0*?966)?(11|12|13|14|16|17)\d{7}$/,
};
Settings.available_vanities_kw = "0,1,2,3,4,7,45";
Settings.available_mnp_operators = {
  stc: 1,
  ooredoo: 6,
  zain: 9,
};

Settings.ocr_fields_kw_id = Settings?.enableAddressEdit
  ? {
      35: {
        name: "id_type",
        value: "",
        validations: {
          required: true,
        },
        type: "kw_id",
        valid: false,
        show: true,
        data_submition: true,
        order: 1,
      },
      26: {
        name: "nationality_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 2,
      },
      7: {
        name: "id_number",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 3,
      },
      311: {
        name: "contact_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: "",
          minLength: "",
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 4,
      },
      25: {
        name: "surnameAndGivenNames",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: false,
        order: 5,
      },
      full_address: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        show_address_modal: false,
        data_submition: false,
        address_submition: false,
        order: 6,
      },
      5: {
        name: "dob",
        value: "",
        validations: {
          required: true,
          minAge: 18,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 7,
        date_format: true,
      },
      3: {
        name: "expiry_date",
        value: "",
        validations: {
          required: true,
          expiry: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 8,
        date_format: true,
      },
      12: {
        name: "gender",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 9,
      },
      2: {
        name: "civil_id",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: false,
      },
      11: {
        name: "nationality_name",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: true,
      },
      9: {
        name: "first_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      8: {
        name: "last_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      governorate: {
        name: "governorate_id",
        value: "",
        validations: {
          required: true,
        },
        order_address: 1,
        valid: false,
        show_address_modal: true,
        address_submition: true,
        disabled: false,
      },
      // 64: {
      //     name: "area_id",
      //     value: "",
      //     validations: {
      //         required: true
      //     },
      //     valid: false,
      //     show_address_modal: true,
      //     order_address: 2,
      //     address_submition: true
      // },
      77: {
        name: "area_id",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 2,
        address_submition: true,
        disabled: false,
      },
      190: {
        name: "block",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 3,
        address_submition: true,
        disabled: false,
      },
      76: {
        name: "street",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 4,
        address_submition: true,
        disabled: false,
      },
      67: {
        name: "building",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 5,
        address_submition: true,
        disabled: false,
      },
      68: {
        name: "floor",
        value: "",
        validations: {
          required: false,
          maxLength: 50,
        },
        valid: true,
        show_address_modal: true,
        order_address: 6,
        data_submition: false,
        address_submition: true,
        disabled: false,
      },
      292: {
        name: "paci_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: 50,
        },
        valid: true,
        show_address_modal: true,
        order_address: 7,
        data_submition: true,
        address_submition: false,
        disabled: false,
      },
      additional_direction: {
        name: "direction",
        value: "",
        validations: {
          required: false,
          maxLength: 200,
        },
        valid: true,
        show_address_modal: true,
        order_address: 8,
        data_submition: false,
        address_submition: true,
        disabled: false,
      },
      area: {
        name: "area",
        value: "",
        validations: {},
        valid: true,
        show_address_modal: false,
        address_submition: true,
      },
    }
  : {
      35: {
        name: "id_type",
        value: "",
        validations: {
          required: true,
        },
        type: "kw_id",
        valid: false,
        show: true,
        data_submition: true,
        order: 1,
      },
      26: {
        name: "nationality_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 2,
      },
      7: {
        name: "id_number",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 3,
      },
      311: {
        name: "contact_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: "",
          minLength: "",
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 4,
      },
      25: {
        name: "surnameAndGivenNames",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: false,
        order: 5,
      },
      full_address: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        show_address_modal: false,
        data_submition: false,
        address_submition: false,
        order: 6,
      },
      5: {
        name: "dob",
        value: "",
        validations: {
          required: true,
          minAge: 18,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 7,
        date_format: true,
      },
      3: {
        name: "expiry_date",
        value: "",
        validations: {
          required: true,
          expiry: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 8,
        date_format: true,
      },
      12: {
        name: "gender",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 9,
      },
      2: {
        name: "civil_id",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: false,
      },
      11: {
        name: "nationality_name",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: true,
      },
      9: {
        name: "first_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      8: {
        name: "last_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      governorate: {
        name: "governorate_id",
        value: "",
        validations: {
          required: true,
        },
        valid: true,
        show_address_modal: true,
        order_address: 1,
        address_submition: true,
        disabled: true,
      },
      // 64: {
      //     name: "area_id",
      //     value: "",
      //     validations: {
      //         required: true
      //     },
      //     valid: false,
      //     show_address_modal: true,
      //     order_address: 2,
      //     address_submition: true
      // },
      77: {
        name: "area_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show_address_modal: true,
        order_address: 2,
        address_submition: true,
        disabled: true,
      },
      190: {
        name: "block",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 3,
        address_submition: true,
        disabled: true,
      },
      76: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show_address_modal: true,
        order_address: 4,
        address_submition: true,
        disabled: true,
      },
      67: {
        name: "building",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 5,
        address_submition: true,
        disabled: true,
      },
      68: {
        name: "floor",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 6,
        data_submition: false,
        address_submition: true,
        disabled: true,
      },
      292: {
        name: "paci_number",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 7,
        data_submition: true,
        address_submition: false,
        disabled: true,
      },
      additional_direction: {
        name: "direction",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 8,
        data_submition: false,
        address_submition: true,
        disabled: true,
      },
      area: {
        name: "area",
        value: "",
        validations: {},
        valid: true,
        show_address_modal: false,
        address_submition: true,
      },
    };

Settings.ocr_fields_kw_passport_gcc = Settings?.enableAddressEdit
  ? {
      35: {
        name: "id_type",
        value: "",
        validations: {
          required: true,
        },
        type: "kw_passport_gcc",
        valid: false,
        show: true,
        data_submition: true,
        order: 1,
      },
      26: {
        name: "nationality_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 2,
      },
      7: {
        name: "id_number",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 3,
      },
      311: {
        name: "contact_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: "",
          minLength: "",
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 4,
      },
      25: {
        name: "surnameAndGivenNames",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: false,
        order: 5,
      },
      full_address: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        show_address_modal: false,
        data_submition: false,
        address_submition: false,
        order: 6,
      },
      5: {
        name: "dob",
        value: "",
        validations: {
          required: true,
          minAge: 18,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 7,
        date_format: true,
      },
      3: {
        name: "expiry_date",
        value: "",
        validations: {
          required: true,
          expiry: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 8,
        date_format: true,
      },
      12: {
        name: "gender",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 9,
      },
      2: {
        name: "civil_id",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: false,
      },
      11: {
        name: "nationality_name",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: true,
      },
      9: {
        name: "first_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      8: {
        name: "last_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      governorate: {
        name: "governorate_id",
        value: "",
        validations: {
          required: true,
        },
        order_address: 1,
        valid: false,
        show_address_modal: true,
        address_submition: true,
        disabled: false,
      },
      // 64: {
      //     name: "area_id",
      //     value: "",
      //     validations: {
      //         required: true
      //     },
      //     valid: false,
      //     show_address_modal: true,
      //     order_address: 2,
      //     address_submition: true
      // },
      77: {
        name: "area_id",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 2,
        address_submition: true,
        disabled: false,
      },
      190: {
        name: "block",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 3,
        address_submition: true,
        disabled: false,
      },
      76: {
        name: "street",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 4,
        address_submition: true,
        disabled: false,
      },
      67: {
        name: "building",
        value: "",
        validations: {
          required: true,
          maxLength: 50,
        },
        valid: false,
        show_address_modal: true,
        order_address: 5,
        address_submition: true,
        disabled: false,
      },
      68: {
        name: "floor",
        value: "",
        validations: {
          required: false,
          maxLength: 50,
        },
        valid: true,
        show_address_modal: true,
        order_address: 6,
        data_submition: false,
        address_submition: true,
        disabled: false,
      },
      292: {
        name: "paci_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: 50,
        },
        valid: true,
        show_address_modal: true,
        order_address: 7,
        data_submition: true,
        address_submition: false,
        disabled: false,
      },
      additional_direction: {
        name: "direction",
        value: "",
        validations: {
          required: false,
          maxLength: 200,
        },
        valid: true,
        show_address_modal: true,
        order_address: 8,
        data_submition: false,
        address_submition: true,
        disabled: false,
      },
      area: {
        name: "area",
        value: "",
        validations: {},
        valid: true,
        show_address_modal: false,
        address_submition: true,
      },
    }
  : {
      35: {
        name: "id_type",
        value: "",
        validations: {
          required: true,
        },
        type: "kw_passport_gcc",
        valid: false,
        show: true,
        data_submition: true,
        order: 1,
      },
      26: {
        name: "nationality_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 2,
      },
      7: {
        name: "id_number",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 3,
      },
      311: {
        name: "contact_number",
        value: "",
        validations: {
          required: false,
          numberOnly: true,
          maxLength: "",
          minLength: "",
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 4,
      },
      25: {
        name: "surnameAndGivenNames",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: false,
        order: 5,
      },
      full_address: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        show_address_modal: false,
        data_submition: false,
        address_submition: false,
        order: 6,
      },
      5: {
        name: "dob",
        value: "",
        validations: {
          required: true,
          minAge: 18,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 7,
        date_format: true,
      },
      3: {
        name: "expiry_date",
        value: "",
        validations: {
          required: true,
          expiry: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 8,
        date_format: true,
      },
      12: {
        name: "gender",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show: true,
        data_submition: true,
        order: 9,
      },
      2: {
        name: "civil_id",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: false,
      },
      11: {
        name: "nationality_name",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show: false,
        data_submition: true,
      },
      9: {
        name: "first_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      8: {
        name: "last_name",
        value: "",
        validations: {},
        valid: true,
        show: false,
        data_submition: true,
      },
      governorate: {
        name: "governorate_id",
        value: "",
        validations: {
          required: true,
        },
        valid: true,
        show_address_modal: true,
        order_address: 1,
        address_submition: true,
        disabled: true,
      },
      // 64: {
      //     name: "area_id",
      //     value: "",
      //     validations: {
      //         required: true
      //     },
      //     valid: false,
      //     show_address_modal: true,
      //     order_address: 2,
      //     address_submition: true
      // },
      77: {
        name: "area_id",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show_address_modal: true,
        order_address: 2,
        address_submition: true,
        disabled: true,
      },
      190: {
        name: "block",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 3,
        address_submition: true,
        disabled: true,
      },
      76: {
        name: "street",
        value: "",
        validations: {
          required: true,
        },
        valid: false,
        show_address_modal: true,
        order_address: 4,
        address_submition: true,
        disabled: true,
      },
      67: {
        name: "building",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 5,
        address_submition: true,
        disabled: true,
      },
      68: {
        name: "floor",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 6,
        data_submition: false,
        address_submition: true,
        disabled: true,
      },
      292: {
        name: "paci_number",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 7,
        data_submition: true,
        address_submition: false,
        disabled: true,
      },
      additional_direction: {
        name: "direction",
        value: "",
        validations: {
          required: false,
        },
        valid: true,
        show_address_modal: true,
        order_address: 8,
        data_submition: false,
        address_submition: true,
        disabled: true,
      },
      area: {
        name: "area",
        value: "",
        validations: {},
        valid: true,
        show_address_modal: false,
        address_submition: true,
      },
    };
Settings.Topup = {
  number: {
    value: "",
    validations: {
      requiredObject: true,
      maxLengthObj: CONSTANTS.TOP_UP_NUMBER_LENGTH[Settings.version],
      minLength: CONSTANTS.TOP_UP_NUMBER_LENGTH[Settings.version],
      topupNumber: true,
    },
    valid: false,
    touched: false,
    errorMsg: "",
    unique_no: true,
    unique_no_err: "",
  },
  price: {
    value: "",
    validations: {
      requiredObject: true,
      // maxLengthObj: 6,
      maxValue: "",
      minValue: "",
      minValueZero: "",
    },
    valid: false,
    touched: false,
    denomination: {},
    discountDetail: {},
    errorMsg: "",
  },
  submit: false,
};

Settings.get = function (setting) {
  return Settings[setting];
};

export default Settings;
